const { host } = window.location;
const selfcareOriginURL = ((host === 'trost.co.kr') || (host === 'www.trost.co.kr')) ? 'https://selfcare.trost.co.kr' : 'https://dev-selfcare.trost.co.kr';
const counselingOriginURL = ((host === 'trost.co.kr') || (host === 'www.trost.co.kr')) ? 'https://trost.co.kr' : 'https://dev.trost.co.kr';

export {
  selfcareOriginURL,
  counselingOriginURL,
};
